declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

const PIXEL_ID = '2045975310141496'

export function initMetaPixel(): void {
  if (typeof window === 'undefined' || window.fbq) return

  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(t)

  window.fbq('init', PIXEL_ID)
}

export function trackPageView(): void {
  if (window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackViewContent(): void {
  if (window.fbq) {
    window.fbq('track', 'ViewContent', {
      content_name: 'El Salto de Novia a Esposa',
      content_type: 'product',
      value: 9.95,
      currency: 'USD',
    })
  }
}

export function trackAddToCart(): void {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'El Salto de Novia a Esposa',
      content_type: 'product',
      value: 9.95,
      currency: 'USD',
    })
  }
}
